import { FeedbackFormFields } from 'modules/feedback/interfaces/forms';
import React, { FC } from 'react';
import { Controller, FormProvider, UseFormReturn } from 'react-hook-form';
import { ErrorMessage } from 'shared/components/Form/ErrorMessage';
import { TextInput } from 'shared/components/Form/TextInput';

interface CreateFeedbackFormProps {
  form: UseFormReturn<FeedbackFormFields>;
}

export const CreateFeedbackForm: FC<CreateFeedbackFormProps> = ({ form }) => {
  const {
    control,
    formState: { isSubmitted },
  } = form;

  return (
    <FormProvider {...form}>
      <form>
        <Controller
          name="message"
          control={control}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <>
              <TextInput
                multiline
                rows={6}
                value={value}
                onChange={onChange}
                placeholder="Write here..."
                error={isSubmitted && Boolean(error)}
              />
              {isSubmitted && <ErrorMessage error={error?.message} />}
            </>
          )}
        />
      </form>
    </FormProvider>
  );
};
